import { defineComponent as _defineComponent } from 'vue'
import PlainMessage from '@/modules/Chat/api/models/PlainMessage';
import AttachmentList from '@/shared/components/AttachmentList.vue';

interface Props {
    plainMessage: PlainMessage;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlainMessageComponent',
  props: {
    plainMessage: null
  },
  setup(__props: any) {



return { __sfc: true,AttachmentList }
}

})